<template>
  <el-form
    :model="ruleForm"
    :rules="rules"
    ref="ruleForm"
    label-width="100px"
    class="demo-ruleForm"
  >
    <el-row>
      <!-- {{ ruleForm }} -->
      <el-col :span="24">
        <el-form-item :label="$t('devices.inventory.idles')" prop="idles">
          <el-input type="number" v-model="ruleForm.idles"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item :label="$t('devices.inventory.factories')" prop="factories">
          <el-input v-model="ruleForm.factories"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item :label="$t('devices.inventory.repairs')" prop="repairs">
          <el-input v-model="ruleForm.repairs"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item :label="$t('devices.inventory.scraps')" prop="scraps">
          <el-input v-model="ruleForm.scraps"></el-input>
        </el-form-item>
      </el-col>

      <el-col :span="24">
        <el-form-item :label="$t('devices.inventory.total')" prop="total">
          <el-input v-model="ruleForm.total"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item :label="$t('devices.inventory.postRegisters')" prop="postRegisters">
          <el-input v-model="ruleForm.postRegisters"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="24">
        <el-form-item :label="$t('devices.inventory.note')" prop="note">
          <el-input v-model="ruleForm.note"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>
<script>
export default {
  props: {
    formData: {
      type: Object,
      require: true,
      default: () => ({}),
    },
  },
  data() {
    return {
      multiple: true,
      storeList: [
        {
          storeName: "全部",
          storeId: 0,
          nextStoreList: [],
        },
      ],
      defaultProps: {
        label: "storeName",
        children: "nextStoreList",
      },
      selectedStoreIds: [], // 默认选中的key
      tagTypeLists: [], // 价签类型列表
      rules: {
        problems: [
          {
            required: true,
            message: this.$t("devices.inventory.pleaseEnterProblemsNum"),
            trigger: "blur",
          },
        ],
        idles: [
          {
            required: true,
            message: this.$t("devices.inventory.pleaseEnterIdlesNum"),
            trigger: "blur",
          },
        ],
        factories: [
          {
            required: true,
            message: this.$t("devices.inventory.pleaseEnterFactoriesNum"),
            trigger: "blur",
          },
        ],
        repairs: [
          {
            required: true,
            message: this.$t("devices.inventory.pleaseEnterRepairsNum"),
            trigger: "blur",
          },
        ],
        scraps: [
          {
            required: true,
            message: this.$t("devices.inventory.pleaseEnterScrapsNum"),
            trigger: "blur",
          },
        ],
        total: [
          {
            required: true,
            message: this.$t("devices.inventory.pleaseEnterTotalNum"),
            trigger: "blur",
          },
        ],
        postRegisters: [
          {
            required: true,
            message: this.$t("devices.inventory.pleaseEnterPostRegistersNum"),
            trigger: "blur",
          },
        ],
      },
      ruleForm: {
        problems: "", // 异常数
        idles: "", // 闲置数
        factories: "", // 返厂数
        repairs: "", // 报修数
        scraps: "", // 报废数
        total: "", // 实际数
        note: "", // 备注
        postRegisters: "", // 补登数
      },
    };
  },
  watch: {},
  mounted() {
    // this.getStore();
    // this.getTagTypeList();
  },
  created() {
    // this.ruleForm = cloneDeep(this.formData);
  },
  methods: {
    handleCheckChange(data, checked, indeterminate) {
      if (data.storeId == 0 && checked) {
        console.log(data.storeName);
      }
      if (data.storeId == 0 && !checked) {
        console.log("取消全选");
      }
      console.log(this.$refs.tree.getCheckedKeys());
      const selectData = this.$refs.tree.getCheckedKeys();
      const selectNodes = this.$refs.tree.getCheckedNodes();
      const nameLists = selectNodes.map((item) => {
        return item.storeName;
      });
      this.ruleForm.storeNames = nameLists.join(",");
      console.log(selectNodes);
      this.ruleForm.storeIds = [];
      selectData.map((item) => {
        this.ruleForm.storeIds.push(item);
      });
      // this.ruleForm.storeIds = this.$refs.tree.getCheckedKeys()
      console.log(data, checked, indeterminate);
    },
    getTagTypeList() {
      const userData = JSON.parse(localStorage.getItem("userData"));
      const params = {
        merchantId: userData.merchantId,
      };
      getAllTagType(params).then((res) => {
        console.log(res);
        this.tagTypeLists = res.data.data;
      });
    },
    getStore() {
      let userData = JSON.parse(localStorage.getItem("userData"));
      const params = {
        storeId: userData.storeId,
        name: "",
      };
      getStoreList(params).then((res) => {
        console.log(res);
        this.storeList[0].nextStoreList = [res.data.data];
      });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
